import script from "./Game.vue?vue&type=script&setup=true&lang=js"
export * from "./Game.vue?vue&type=script&setup=true&lang=js"

import "./Game.vue?vue&type=style&index=0&id=43f396fe&lang=scss"

const __exports__ = script;

export default __exports__